import { desktopFirstMediaQuery } from '@inflearn/ds-react';

export const INTEGRATED_GNB_HEIGHT = 40;
export const GNB_DESKTOP_HEIGHT = 64;
export const GNB_MOBILE_HEIGHT = 50;

export const fullPageHeight = {
  minHeight: `calc(100vh - ${INTEGRATED_GNB_HEIGHT + GNB_DESKTOP_HEIGHT}px)`,
  [desktopFirstMediaQuery.tablet]: {
    minHeight: `calc(100vh - ${INTEGRATED_GNB_HEIGHT + GNB_MOBILE_HEIGHT}px)`,
  },
};
